import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../context/AuthContext';

const useBlockCheck = (blockedRole) => {
  const { profile, profileLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!profileLoading && profile) {
      if (profile?.blocked && profile?.blocked.includes(blockedRole)) {
        // If blocked, navigate to BlankPage and pass blockedRole dynamically
        navigate('/blank-page', { state: { blockedRole } });
      }
    }
  }, [profile, profileLoading, navigate, blockedRole]);
};

export default useBlockCheck;
